import axios from "axios"
import { useContext } from "react"
import { AppContext } from "../Context/Context"

export const API_URL = 'https://auditaibot.soof.uz'
export const BOT_1 = 'wss://auditaibot.soof.uz/ws/gt1'
export const BOT_2 = "wss://auditaibot.soof.uz/ws/soliq"
export const BOT_3 = "wss://auditaibot.soof.uz/ws/mhxs"
export const TOKEN = localStorage.getItem('token')

// export const handleSendChat = (message) => {
//     const { chatId, setChatId } = useContext(AppContext)

//     axios.post(`${API_URL}/chat`, {
//         title: message.content
//     }, {
//         headers: {
//             Authorization: `Bearer ${TOKEN}`
//         },
//     }).then((res) => {

//     })
// }